import React, { useContext } from "react";
import { Button, Typography } from "@mui/material";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { EXECUTOR_VERIFICATION_ACCEPTED_ID, EXECUTOR_VERIFICATION_IN_REVIEW_ID } from ".";
import { ExecutorVerificationContext } from "ExecutorVerificationContextWrapper";
import { ATTICUS_CONSUMER_APP_HOST_ORIGINAL } from "../../../constants";
import { Loading } from "views/shared/Loading";

export const ApplicationSubmittedScreen = (): JSX.Element => {
  const { steps } = useContext(ExecutorVerificationContext);

  function allStepsApproved():boolean {
    return !steps?.find(s => s.statusId !== EXECUTOR_VERIFICATION_ACCEPTED_ID)
  }

  function someStepsInReview():boolean {
    return !!steps?.find(s => s.statusId === EXECUTOR_VERIFICATION_IN_REVIEW_ID)
  }

  return (
    <FlowScreenWrapper>
      <div style={{textAlign:"center"}}>
        {(!steps || steps.length === 0) ? 
          <Loading /> :
        someStepsInReview() ? <>
          <img src="/static/images/Paper_Airplane.svg" style={{width:"200px", height:"200px", marginBottom:"2rem"}} />
          <Typography variant="h3" component="p" style={{marginBottom:"2rem"}}>We’ve received your request to become an Atticus Verified Executor™</Typography>
          <Typography variant="body1" component="p" style={{marginBottom:"2rem"}}>Our team will review your application over the next few business days and let you know once your status has been changed to Verified.</Typography>
        </>: allStepsApproved() ? <>
          <img src="/static/images/Verified_Executor_Badge.svg" style={{width:"200px", height:"200px", marginBottom:"2rem"}} />
          <Typography variant="h3" component="p" style={{marginBottom:"2rem"}}>Congratulations! You’re now an Atticus Verified Executor™</Typography>
          <Typography variant="body1" component="p" style={{marginBottom:"2rem"}}>We’ve added your Atticus Verified Executor™ document to your File Cabinet. You can use this anywhere you need to prove your identity as the Executor of the estate.</Typography>
        </> : <>
          <Typography variant="h3" component="p" style={{marginBottom:"2rem"}}>Please contact us regarding your application</Typography>
          <Typography variant="body1" component="p" style={{marginBottom:"2rem"}}>
            We’ve found some issues with your application to become an Atticus Verified Executor™.  
            Please <a href="https://app.weareatticus.com/help">contact us</a> and we’ll figure out what to do next!
          </Typography>
        </>}

        
        <a href={`${ATTICUS_CONSUMER_APP_HOST_ORIGINAL}/home`}><Button variant="contained" color="secondary">Return to home</Button></a>
      </div>
    </FlowScreenWrapper>
  )
}
